import React, { useEffect, useState } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import { Button, Grid } from '@material-ui/core'
import { ModalMapsEdit } from '../../Maps/MapsEdit/ModalMapsEdit'
import swal from 'sweetalert'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { deleteLocationById } from '../../../../../services/Elegibilidad/delete'
import AddIcon from '@material-ui/icons/Add'
import { useEligibility } from '../../../../../context/EligibilityContext'
import { ModalMaps } from '../../Maps/ModalMaps'
import { getLocationsByForm } from '../../../../../services/Elegibilidad/get'
import { saveDrafElegibilityForm } from '../../../../../services/Elegibilidad/create'

const Table31 = ({
  idElegibilityForm,
  formik,
  ProjectSites,
  EligibilityForm,
}) => {
  const [open, setOpen] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [dataRow, setDataRow] = useState({})
  const [positionsCurrent, setpositionsCurrent] = useState({})
  const [address, setAddress] = useState('')
  const [state] = useEligibility()
  const [disabled, setDisabled] = useState(false)
  const [tableDataLocation, setTableDataLocation] = useState([])

  // funcion para obtener las ubicaciones del proyecto
  const getDataTableLocation = async () => {
    try {
      const response = await getLocationsByForm(idElegibilityForm)
      if (response.Success) {
        setTableDataLocation(response.Data)
        if (response.Data.length !== 0 && response.Data.length === ProjectSites)
          formik.setFieldValue('validTable31', true)
        else {
          formik.setFieldValue('validTable31', false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const saveForm = async () => {
    try {
      const object = {
        ...formik.values,
        IdTechnicalTraining:
          formik.values.IdTechnicalTraining === ''
            ? null
            : formik.values.IdTechnicalTraining,
        ReceivedCredits:
          formik.values.ReceivedCredits === ''
            ? null
            : formik.values.ReceivedCredits,
        RiskCommittees:
          formik.values.RiskCommittees === ''
            ? null
            : formik.values.RiskCommittees,
        ClimaticInformation:
          formik.values.ClimaticInformation === ''
            ? null
            : formik.values.ClimaticInformation,
        FoodSafety:
          formik.values.FoodSafety === '' ? null : formik.values.FoodSafety,
        AccDrinkinWater:
          formik.values.AccDrinkinWater === ''
            ? null
            : formik.values.AccDrinkinWater,
        AdwRain: formik.values.AdwRain === '' ? null : formik.values.AdwRain,
        AdwGroundWater:
          formik.values.AdwGroundWater === ''
            ? null
            : formik.values.AdwGroundWater,
        AdwDrinkinWater:
          formik.values.AdwDrinkinWater === ''
            ? null
            : formik.values.AdwDrinkinWater,
        AdwVariousSources:
          formik.values.AdwVariousSources === ''
            ? null
            : formik.values.AdwVariousSources,
        IdTechnicalTrainingFrec:
          formik.values.IdTechnicalTrainingFrec === ''
            ? null
            : formik.values.IdTechnicalTrainingFrec,
        TechnicalTrainingEmplWomen:
          formik.values.TechnicalTrainingEmplWomen === ''
            ? null
            : formik.values.TechnicalTrainingEmplWomen,
        TechnicalTrainingEmplMen:
          formik.values.TechnicalTrainingEmplMen === ''
            ? null
            : formik.values.TechnicalTrainingEmplMen,
        TechnicalTrainingManager:
          formik.values.TechnicalTrainingManager === ''
            ? null
            : formik.values.TechnicalTrainingManager,
        TtEnvironmental:
          formik.values.TtEnvironmental === ''
            ? null
            : formik.values.TtEnvironmental,
        TtSocial: formik.values.TtSocial === '' ? null : formik.values.TtSocial,
        TtFinance:
          formik.values.TtFinance === '' ? null : formik.values.TtFinance,
        TtMarketAccess:
          formik.values.TtMarketAccess === ''
            ? null
            : formik.values.TtMarketAccess,
        TtInnovation:
          formik.values.TtInnovation === '' ? null : formik.values.TtInnovation,
        TtOther: formik.values.TtOther === '' ? null : formik.values.TtOther,
        TtDetail: formik.values.TtDetail === '' ? null : formik.values.TtDetail,
        FrNotReceived:
          formik.values.FrNotReceived === ''
            ? null
            : formik.values.FrNotReceived,
        FrOther: formik.values.FrOther === '' ? null : formik.values.FrOther,
        FrCredits:
          formik.values.FrCredits === '' ? null : formik.values.FrCredits,
        FrDonations:
          formik.values.FrDonations === '' ? null : formik.values.FrDonations,
        FrSubsidies:
          formik.values.FrSubsidies === '' ? null : formik.values.FrSubsidies,
        FrDetail: formik.values.FrDetail === '' ? null : formik.values.FrDetail,
        RuWorkingCapital:
          formik.values.RuWorkingCapital === ''
            ? null
            : formik.values.RuWorkingCapital,
        RuEquipmentPurchase:
          formik.values.RuEquipmentPurchase === ''
            ? null
            : formik.values.RuEquipmentPurchase,
        RuPreinvestment:
          formik.values.RuPreinvestment === ''
            ? null
            : formik.values.RuPreinvestment,
        RuRealEstatePurchase:
          formik.values.RuRealEstatePurchase === ''
            ? null
            : formik.values.RuRealEstatePurchase,
      }

      const response = await saveDrafElegibilityForm({
        ...EligibilityForm,
        ...object,
        IdFormAction: 24,
      })
      if (!response.Success) {
        console.log(response.Message)
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    if (
      (ProjectSites !== null &&
        Number(ProjectSites) === tableDataLocation.length) ||
      tableDataLocation.length >= Number(ProjectSites)
    ) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [tableDataLocation, ProjectSites])

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null
    ) {
      getDataTableLocation()
    }
  }, [state.step, ProjectSites])

  const handleDelete = async (id) => {
    try {
      const response = await deleteLocationById(id)
      if (response.Success) getDataTableLocation()
    } catch (error) {
      console.log(error)
    }
  }

  const columns = [
    {
      title: 'Latitud',
      field: 'Latitud',
      filterPlaceholder: 'filter',
    },
    {
      title: 'Longitud',
      field: 'Longitude',
      // align: 'center',
      grouping: false,
    },
    {
      title: 'Dirección ',
      field: 'Address',
      // emptyValue: () => <em>null</em>,
      // render: (rowData) => (
      //   <div
      //     style={{
      //       background: rowData.age >= 18 ? '#008000aa' : '#f90000aa',
      //       borderRadius: '4px',
      //       paddingLeft: 5,
      //     }}
      //   >
      //     {rowData.age >= 18 ? '18+' : '18-'}
      //   </div>
      // ),
      searchable: true,
      export: true,
    },
    // { title: 'Gender', field: 'gender', lookup: { M: 'Male', F: 'Female' } },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableDataLocation}
            actions={[
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={
                      !disabled
                        ? { backgroundColor: '#27C27D', color: '#FFFFFF' }
                        : {}
                    }
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                    disabled={disabled}
                    onClick={() => setOpenModal(true)}
                  >
                    Agregar Ubicación
                  </Button>
                ),
                tooltip: 'Agregar',
                position: 'toolbar',
              },

              {
                icon: () => <EditIcon style={{ color: '#0d53ad' }} />,

                tooltip: 'Editar',
                onClick: (event, rowData) => {
                  setpositionsCurrent({})
                  setDataRow([])
                  setDataRow(rowData)

                  setpositionsCurrent({
                    lat: parseFloat(rowData.Latitud),
                    lng: parseFloat(rowData.Longitude),
                  })
                  setAddress(rowData.Address)
                  setOpen(true)
                },
              },
              {
                icon: () => <DeleteIcon style={{ color: 'red' }} />,
                tooltip: 'Eliminar ubicación',
                onClick: (event, rowData) => {
                  swal({
                    title: '¿Está seguro de eliminar el registro?',
                    icon: 'warning',
                    buttons: ['No', 'Si'],
                    dangerMode: true,
                  }).then(function (isConfirm) {
                    if (isConfirm) {
                      handleDelete(rowData.IdProjectDevelopmentLocation)
                    }
                  })
                },
              },
            ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              customFilterAndSearch: 'Address',
              // filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              // addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',

              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              // grouping: true,
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={
              {
                // Add: () => <AddIcon />,
                // Edit: () => <EditIcon />,
              }
            }
          />
        </Grid>
      </Grid>
      <ModalMaps
        open={openModal}
        setOpen={setOpenModal}
        getDataTableLocation={getDataTableLocation}
        saveForm={saveForm}
      />
      <ModalMapsEdit
        open={open}
        setOpen={setOpen}
        dataRow={dataRow}
        positionsCurrent={positionsCurrent}
        setpositionsCurrent={setpositionsCurrent}
        address={address}
        setAddress={setAddress}
        getDataTableLocation={getDataTableLocation}
        saveForm={saveForm}
      />
    </div>
  )
}

export default React.memo(Table31)
